import React, { useState } from "react";
import AxiosInstance from "../../utils/axiosInstance";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const MeetingAndAttandanceModel = ({ show, onClose }) => {
  const [uploadData, setUploadData] = useState({
    name: "", // You might not need this based on the UI
    type: "AL",
    file: null,
  });
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [showLoader, setShowLoader] = useState(false);

  const docTypeOptions = [
    { label: "AL Cron", value: "AL" },
    { label: "MI Cron", value: "MI" },
  ];

  const handleSubmit = async () => {
    const newErrors = {};
    const maxFileSize = 5 * 1024 * 1024;
    const allowedExtensions = {
      AL: ["csv"],
      MI: ["xlsx", "xls"],
    };

    if (!uploadData.file) {
      newErrors.file = "Please select a file.";
    } else {
      const file = uploadData.file;
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (file.size === 0) {
        newErrors.file = "This file is empty.";
      } else if (file.size > maxFileSize) {
        // newErrors.file = "File must be 5MB or less.";
      } else if (
        uploadData.type &&
        allowedExtensions[uploadData.type] &&
        !allowedExtensions[uploadData.type].includes(fileExtension)
      ) {
        newErrors.file = `Invalid file type for ${
          docTypeOptions.find((opt) => opt.value === uploadData.type)?.label
        }. Allowed: ${allowedExtensions[uploadData.type].join(", ")}`;
      } else if (
        !Object.values(allowedExtensions).flat().includes(fileExtension)
      ) {
        newErrors.file = `Invalid file type. Allowed: ${Object.values(
          allowedExtensions,
        )
          .flat()
          .join(", ")}`;
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    try {
      setShowLoader(true);

      const formData = new FormData();
      formData.append("file", uploadData.file);
      formData.append("doc_type", uploadData.type);

      const response = await AxiosInstance.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_UPLOAD_FILE_FOR_CRON}`,
        formData,
      );

      // If it reaches here, the interceptor already validated the success statusCode
      toast.success(response?.data?.message || "File uploaded successfully!");

      setUploadData({ name: "", type: "AL", file: null });
      setErrors({});
      onClose();

      // Navigate and pass state
      navigate("/temp_data", {
        state: { doc_type: uploadData.type },
      });
    } catch (error) {
      // We only toast here if it's a generic catch-all.
      // Your interceptor already toasts for 400 and 401 errors.
      console.error("Submission Error:", error);

      // Fallback toast only if the error wasn't handled by the interceptor
      if (!error?.response) {
        toast.error("Network error. Please check your connection.");
      }
    } finally {
      setShowLoader(false);
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Upload Cron/Sync File</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={showLoader}
            />
          </div>
          <div className="modal-body">
            {/* Document Type Selector */}
            <div className="mb-3">
              <label className="form-label">Document Type</label>
              <select
                className="form-select"
                value={uploadData.type}
                onChange={(e) =>
                  setUploadData({ ...uploadData, type: e.target.value })
                }
              >
                {docTypeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* File Field */}
            <div className="mb-3">
              <label className="form-label">File</label>
              <input
                type="file"
                className="form-control"
                onChange={(e) =>
                  setUploadData({ ...uploadData, file: e.target.files[0] })
                }
              />
              <small className="text-muted">
                Accepted file types: <strong>FOR AL CSV</strong>,{" "}
                <strong>FOR MI XLS</strong>
              </small>
              {errors.file && <div className="text-danger">{errors.file}</div>}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={showLoader}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center justify-content-center"
              onClick={handleSubmit}
              disabled={showLoader}
              style={{ minWidth: "120px", height: "45px" }}
            >
              {showLoader ? (
                <span className="d-flex align-items-center">
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                  Uploading...
                </span>
              ) : (
                "Upload"
              )}
            </button>
          </div>

          <div className="modal-footer">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>File Type</th>
                  <th>Demo Link</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>AL File (CSV)</td>
                  <td>
                    <a
                      href="https://dev.contractorcn.com/AL_AND_MI_CRON_FILES/AL_demo.csv"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Demo
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>MI File (XLS)</td>
                  <td>
                    <a
                      href="https://dev.contractorcn.com/AL_AND_MI_CRON_FILES/MI_demo.xls"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Demo
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingAndAttandanceModel;
